<div class="input-grid-gaps grid-6col">
    <app-radio-input class="fr-6" [form]="form" id="insuranceAdministrator" layout="horizontal"
        [staticOptions]="csszInsuranceAdministratorEnumOptions" [autoSelectFirst]="true"></app-radio-input>

    <app-text-input [form]="form" class="fr-2" id="sszCode" [prefix]="prefix"></app-text-input>

    <app-date-input [form]="form" class="fr-2" id="dateFrom" [showTime]="false" [prefix]="prefix"></app-date-input>

    <hr class="fr-6">

    <div class="fr-3">{{ prefix + 'name' | translate }}: {{ selectedItem?.name }}</div>
    <div class="fr-3">{{ prefix + 'decisionNumber' | translate }}: {{ selectedItem?.decisionNumber }}</div>

    <div class="fr-3">{{ prefix + 'surname' | translate }}: {{ selectedItem?.surname }}</div>
    <div class="fr-3">{{ prefix + 'doctorName' | translate }}: {{ selectedItem?.doctorName }} ({{ selectedItem?.icpe }}
        )
    </div>

    <div class="fr-3">{{ prefix + 'insuranceNumber' | translate }}: {{ selectedItem?.insuranceNumber }}</div>
    <div class="fr-3">{{ prefix + 'from' | translate }}: {{ selectedItem?.namePzs }}</div>

    <hr class="fr-6">
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons primaryButtonLabel="sickNotes.buttons.sendRequest"
        (primaryClickEvent)="confirm()"
        (secondaryClickEvent)="dialogRef.close()">
    </app-action-buttons>
</div>
